import { onDomReady } from '../utils/dom';

function readMore() {
    const reads = document.querySelectorAll('.read_more');

    if (reads.length == 0) return;

    let text = [];
    let currentEl;
    let nextEl;

    reads.forEach((el, index) => {
        currentEl = el.parentElement?.nextElementSibling;
        text[index] = '';

        do {
            if (!currentEl) currentEl = nextEl;
            text[index] += currentEl.outerHTML;
            nextEl = currentEl.nextElementSibling;
            currentEl.remove();
            currentEl = undefined;
        } while (!nextEl.classList.contains('end_of_read'));

        nextEl.remove();

        el.addEventListener('click', function (e) {
            e.preventDefault();
            el.parentElement.outerHTML = text[index];
        });
    });
}

onDomReady(() => {
    readMore();
});
